export default {
  courseList: state => state.courseList,
  courseSubjectDetail: state => state.courseSubjectDetail
  // courseSubjectList: state => state.courseSubjectList
}
